module.exports = __webpack_public_path__ + "img/wallpaper_third.b64020ec.png";